(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 58633:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(10046);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75578);
/* harmony import */ var _svg_Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24555);


const IconCancelSmall = (param)=>/*#__PURE__*/ {
    let { stroke , strokeWidth , ...rest } = param;
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_svg_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        ...rest,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
            d: "M16.2426 7.75729L12 11.9999M12 11.9999L7.75736 16.2426M12 11.9999L16.2426 16.2426M12 11.9999L7.75736 7.75729",
            stroke: stroke || "#9090A0",
            strokeWidth: strokeWidth || "1.5",
            strokeLinecap: "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconCancelSmall);


/***/ }),

/***/ 36744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75578);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40102);


const ToggleSwitch = (param)=>{
    let { name , ...rest } = param;
    const id = name ? "".concat(name, "-toggle") : "toggle";
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(ToggleCheckbox, {
                id: id,
                type: "checkbox",
                ...rest
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(CheckBoxLabel, {
                htmlFor: id
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ToggleSwitch);
const CheckBoxLabel = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("label", {
    target: "emzy3od0"
})("position:relative;display:flex;align-items:center;justify-content:space-between;cursor:pointer;width:48px;height:24px;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.gray3;
}, ";border-radius:12px;transition:background-color 0.2s;&::after{content:'';position:absolute;top:2px;left:2px;width:20px;height:20px;border-radius:45px;transition:0.2s;background-color:#fff;box-shadow:0 0 2px 0 rgba(10,10,10,0.29);}");
const ToggleCheckbox = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("input", {
    target: "emzy3od1"
})("position:absolute;height:0;width:0;visibility:hidden;&:checked + ", CheckBoxLabel, "{background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.gray6;
}, ";&::after{content:'';position:absolute;top:2px;left:calc(100% - 2px);width:20px;height:20px;border-radius:45px;transition:0.2s;background:#fff;box-shadow:0 0 2px 0 rgba(10,10,10,0.29);transform:translateX(-100%);}}");


/***/ }),

/***/ 66476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97759);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72208);
/* harmony import */ var _useGetUserTemplate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80460);
/* harmony import */ var _lib_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93080);
/* harmony import */ var _store_route_home_currentCategory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28693);
/* harmony import */ var _store_route_home_currentUserTemplate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85289);
/* harmony import */ var _store_toast_useToast__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68529);







const useCardItemMutation = ()=>{
    const { fireToast  } = (0,_store_toast_useToast__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    const queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__.useQueryClient)();
    const currentCategory = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilValue */ .sJ)(_store_route_home_currentCategory__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
    const currentTemplate = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilValue */ .sJ)(_store_route_home_currentUserTemplate__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
    const invalidateCurrentUserTemplate = ()=>{
        queryClient.invalidateQueries([
            _useGetUserTemplate__WEBPACK_IMPORTED_MODULE_1__/* .USER_TEMPLATE_QUERY_KEY */ .Q,
            currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id
        ]);
    };
    const createCardItemMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__.useMutation)((param)=>{
        let { itemName , important  } = param;
        if (!currentCategory) throw new Error("카테고리를 생성해 주세요.");
        if (!currentTemplate) throw new Error("템플릿을 생성해 주세요.");
        const requestData = {
            itemName,
            important,
            categoryId: currentCategory.id,
            templateId: currentTemplate.id
        };
        return (0,_lib_api__WEBPACK_IMPORTED_MODULE_2__/* .post */ .v_)("/template/item", requestData);
    }, {
        onSuccess: ()=>{
            invalidateCurrentUserTemplate();
        },
        onError: (error)=>{
            fireToast({
                content: error.message
            });
        }
    });
    const editCardItemMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__.useMutation)({
        mutationFn: (editedCardItem)=>{
            if (!currentTemplate) throw new Error("");
            const requestData = {
                ...editedCardItem,
                templateId: currentTemplate.id
            };
            return (0,_lib_api__WEBPACK_IMPORTED_MODULE_2__/* .patch */ .r$)("/template/item", requestData);
        },
        onSuccess: ()=>{
            invalidateCurrentUserTemplate();
        }
    });
    const editCardItemTakeMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__.useMutation)({
        mutationFn: (toggledCardItem)=>{
            if (!currentTemplate) throw new Error("");
            const requestData = {
                ...toggledCardItem,
                templateId: currentTemplate.id
            };
            return (0,_lib_api__WEBPACK_IMPORTED_MODULE_2__/* .patch */ .r$)("/template/item", requestData);
        },
        onMutate: async (editedCardItem)=>{
            await queryClient.cancelQueries([
                _useGetUserTemplate__WEBPACK_IMPORTED_MODULE_1__/* .USER_TEMPLATE_QUERY_KEY */ .Q,
                currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id
            ]);
            const prevUserTemplate = queryClient.getQueryData([
                _useGetUserTemplate__WEBPACK_IMPORTED_MODULE_1__/* .USER_TEMPLATE_QUERY_KEY */ .Q,
                currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id
            ]);
            queryClient.setQueryData([
                _useGetUserTemplate__WEBPACK_IMPORTED_MODULE_1__/* .USER_TEMPLATE_QUERY_KEY */ .Q,
                currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id
            ], (old)=>{
                if (typeof old === "undefined") return undefined;
                const eachTemplates = old.result;
                const updatedTemplates = eachTemplates.map((template)=>{
                    const updatedItems = template.items.map((item)=>{
                        if (item.id === editedCardItem.itemId) return {
                            ...item,
                            take: editedCardItem.isTake
                        };
                        return item;
                    });
                    return {
                        ...template,
                        items: updatedItems
                    };
                });
                return {
                    result: [
                        ...updatedTemplates
                    ]
                };
            });
            return prevUserTemplate;
        }
    });
    const deleteCardItemMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__.useMutation)((param)=>{
        let { itemId  } = param;
        if (!currentTemplate) throw new Error("");
        const requestData = {
            itemId,
            templateId: currentTemplate.id
        };
        return (0,_lib_api__WEBPACK_IMPORTED_MODULE_2__/* .del */ .IV)("/template/item", {
            data: requestData
        });
    }, {
        onSuccess: ()=>{
            invalidateCurrentUserTemplate();
        }
    });
    return {
        createCardItemMutation,
        editCardItemMutation,
        editCardItemTakeMutation,
        deleteCardItemMutation
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCardItemMutation);


/***/ }),

/***/ 80460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ USER_TEMPLATE_QUERY_KEY; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97759);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72208);
/* harmony import */ var _lib_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93080);
/* harmony import */ var _store_route_home_currentCategory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28693);




const getUserTemplate = (categoryId)=>(0,_lib_api__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U2)("/template/user?category=".concat(categoryId));
const USER_TEMPLATE_QUERY_KEY = "user_template";
const useGetUserTemplate = ()=>{
    var ref;
    const currentCategory = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilValue */ .sJ)(_store_route_home_currentCategory__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
    const query = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__.useQuery)({
        queryKey: [
            USER_TEMPLATE_QUERY_KEY,
            currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id
        ],
        queryFn: ()=>getUserTemplate(currentCategory.id),
        enabled: Boolean(currentCategory)
    });
    return {
        ...query,
        data: (ref = query.data) === null || ref === void 0 ? void 0 : ref.result
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetUserTemplate);


/***/ }),

/***/ 10046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-5128de1cdb/0/cache/@emotion-react-npm-11.10.0-06b9abb1e2-6d692e43ff.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(75578);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-styled-virtual-2aaf7f2de3/0/cache/@emotion-styled-npm-11.10.0-ee745c48ee-f2a3e9798f.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(40102);
// EXTERNAL MODULE: ./.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/throttle.js
var throttle = __webpack_require__(83469);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ./src/hooks/life-cycle/useDidUpdate.ts

const useDidUpdate = (callback, dependencyList)=>{
    const didMountRef = (0,react.useRef)(false);
    (0,react.useEffect)(()=>{
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        callback();
    }, [
        ...dependencyList
    ]);
};
/* harmony default export */ var life_cycle_useDidUpdate = (useDidUpdate);

;// CONCATENATED MODULE: ./src/components/carousel/Indicator.tsx





const Indicator = (param)=>{
    let { carouselWrapper , onIndexChange  } = param;
    const childrenLength = carouselWrapper ? carouselWrapper.childNodes.length : 0;
    const childrenIds = (0,react.useMemo)(()=>Array.from(Array(childrenLength).keys()), [
        childrenLength
    ]);
    const { currentIndex  } = useIndicator({
        carouselWrapper,
        onIndexChange
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        children: childrenIds.map((eachIndex)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dot, {
                isSelected: currentIndex === eachIndex
            }, eachIndex))
    });
};
const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e12cua5g0"
})({
    height: "6px",
    margin: "8px 0",
    display: "flex",
    gap: "4px",
    justifyContent: "center",
    alignItems: "center"
});
const Dot = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e12cua5g1"
})({
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    transition: "background-color .3s"
}, (param)=>{
    let { theme , isSelected  } = param;
    return {
        backgroundColor: isSelected ? theme.colors.gray6 : theme.colors.gray3
    };
});
/* harmony default export */ var carousel_Indicator = (Indicator);
const useIndicator = (param)=>{
    let { carouselWrapper , onIndexChange  } = param;
    const [currentIndex, setCurrentIndex] = (0,react.useState)(null);
    const throttledOnScroll = (0,react.useMemo)(()=>throttle_default()(()=>{
            if (!carouselWrapper) return;
            const { offsetWidth , scrollLeft  } = carouselWrapper;
            const tempIndex = Math.round(scrollLeft / offsetWidth);
            setCurrentIndex(tempIndex);
        }, 300), [
        carouselWrapper
    ]);
    life_cycle_useDidUpdate(()=>{
        if (currentIndex === null) return;
        onIndexChange === null || onIndexChange === void 0 ? void 0 : onIndexChange(currentIndex);
    }, [
        currentIndex
    ]);
    (0,react.useEffect)(()=>{
        if (!carouselWrapper) return;
        throttledOnScroll();
        carouselWrapper.addEventListener("scroll", throttledOnScroll);
        return ()=>{
            carouselWrapper.removeEventListener("scroll", throttledOnScroll);
        };
    }, [
        throttledOnScroll
    ]);
    return {
        currentIndex
    };
};

;// CONCATENATED MODULE: ./src/components/carousel/Carousel.tsx




const CarouselWrapper = /*#__PURE__*/ (0,react.forwardRef)(function CarouselWrapper(param, forwardedRef) {
    let { children  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Carousel_Wrapper, {
        ref: forwardedRef,
        children: children
    });
});
const Carousel_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "ew9m7250"
})({
    width: "100%",
    scrollSnapType: "x mandatory",
    display: "flex",
    // NOTE: 이후 사용할 때 수정 필요
    gap: "55px",
    overflowX: "scroll"
});
const CarouselItem = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Item, {
        children: children
    });
};
const Item = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("article", {
    target: "ew9m7251"
})({
    scrollSnapAlign: "center",
    flexShrink: 0,
    width: "100%"
});
/**
 * Carousel에 필요한 컴포넌트들을 사용할 수 있어요
 *
 * @example
 * ```tsx
 * <Carousel.Wrapper ref={setCarouselWrapper}>
    <Carousel.Item>
      first
    </Carousel.Item>
    // ...
  </Carousel.Wrapper>
  <Carousel.Indicator carouselWrapper={carouselWrapper} />
 * ```
 *
 */ const Carousel = {
    Wrapper: CarouselWrapper,
    Item: CarouselItem,
    Indicator: carousel_Indicator
};
/* harmony default export */ var carousel_Carousel = (Carousel);

// EXTERNAL MODULE: ./src/components/loading/FixedSpinner.tsx
var FixedSpinner = __webpack_require__(90680);
// EXTERNAL MODULE: ./src/components/loading/LoadingHandler.tsx
var LoadingHandler = __webpack_require__(61912);
// EXTERNAL MODULE: ./src/components/navigation/BottomNavigation.tsx + 2 modules
var BottomNavigation = __webpack_require__(21619);
// EXTERNAL MODULE: ./src/components/navigation/DefaultAppBar.tsx + 1 modules
var DefaultAppBar = __webpack_require__(11568);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-4e7940a640/0/cache/next-npm-13.0.2-b39abd22d0-f6fea2ee34.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(77182);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./.yarn/__virtual__/recoil-virtual-459f56a2cd/0/cache/recoil-npm-0.7.5-b0fe76743a-19b410cca6.zip/node_modules/recoil/es/index.js
var es = __webpack_require__(72208);
// EXTERNAL MODULE: ./src/components/button/LabelButton.tsx
var LabelButton = __webpack_require__(81919);
// EXTERNAL MODULE: ./src/components/navigation/AppBar.tsx + 1 modules
var AppBar = __webpack_require__(81660);
// EXTERNAL MODULE: ./src/components/portal/BottomSheet.tsx
var BottomSheet = __webpack_require__(75153);
;// CONCATENATED MODULE: ./src/components/alarm/bottom-sheet/SelectItem.tsx


const SelectItem = (param)=>{
    let { text , onClick , active =false  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectItem_Wrapper, {
        active: active,
        onClick: onClick,
        children: text
    });
};
/* harmony default export */ var bottom_sheet_SelectItem = (SelectItem);
const SelectItem_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "el863qk0"
})({
    padding: "7px 16px",
    borderRadius: "8px"
}, (param)=>{
    let { active , theme  } = param;
    return {
        ...theme.typographies.button2,
        color: active ? theme.colors.white : theme.colors.gray4,
        backgroundColor: active ? theme.colors.gray4 : theme.colors.gray1
    };
});

// EXTERNAL MODULE: ./.yarn/cache/dayjs-npm-1.11.7-d5cd5b2919-5003a7c1dd.zip/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(69199);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/debounce.js
var debounce = __webpack_require__(80875);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./src/components/scrollable-date-time-picker/ScrollItem.tsx



const ScrollItem = (param)=>{
    let { item , align , selectedItem , height  } = param;
    const isEmptyItem = item.toString().includes("empty");
    const isSelected = item === selectedItem;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ScrollItem_Item, {
        align: align,
        isSelected: isSelected,
        height: height,
        children: isEmptyItem ? "" : item
    }, item);
};
/* harmony default export */ var scrollable_date_time_picker_ScrollItem = (ScrollItem);
const ScrollItem_Item = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e12n64fb0"
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    scrollSnapType: "y mandatory",
    scrollSnapAlign: "center"
}, (param)=>{
    let { height , align , isSelected , theme  } = param;
    return {
        ...isSelected ? theme.typographies.button1 : theme.typographies.button2,
        height,
        justifyContent: align,
        color: isSelected ? "white" : theme.colors.gray4
    };
});

;// CONCATENATED MODULE: ./src/components/scrollable-date-time-picker/ScrollBox.tsx




const ScrollBox = (param)=>{
    let { value , items , onChange , align ="center" , width =80  } = param;
    const scrollBox = (0,react.useRef)(null);
    const [selectedItem, setSelectedItem] = (0,react.useState)(items[0]);
    (0,react.useEffect)(()=>{
        var ref;
        const pickedIdx = items.findIndex((item)=>item === value);
        (ref = scrollBox.current) === null || ref === void 0 ? void 0 : ref.scrollTo(0, pickedIdx * BUTTON_HEIGHT);
    }, [
        value
    ]);
    const getIndexByOffsetY = (offsetY)=>{
        const index = Math.round(offsetY / BUTTON_HEIGHT);
        return index;
    };
    const handleScroll = (0,react.useCallback)((e)=>{
        const index = getIndexByOffsetY(e.target.scrollTop);
        setSelectedItem(items[index]);
        onChange(items[index]);
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ScrollBox_Wrapper, {
        onScroll: handleScroll,
        width: width,
        ref: scrollBox,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InnerScrollBox, {
            children: [
                "start-empty",
                ...items,
                "end-empty"
            ].map((item)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(scrollable_date_time_picker_ScrollItem, {
                    item: item,
                    align: align,
                    selectedItem: selectedItem,
                    height: BUTTON_HEIGHT
                }, item))
        })
    });
};
/* harmony default export */ var scrollable_date_time_picker_ScrollBox = (ScrollBox);
const BUTTON_HEIGHT = 40;
const SCROLL_HEIGHT = BUTTON_HEIGHT * 3;
const ScrollBox_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4v4tfr0"
})({
    height: SCROLL_HEIGHT,
    overflowY: "scroll",
    scrollSnapType: "y mandatory",
    scrollSnapAlign: "center",
    overscrollBehavior: "none"
}, (param)=>{
    let { width  } = param;
    return {
        width: "".concat(width, "px")
    };
});
const InnerScrollBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4v4tfr1"
})({
    display: "flex",
    flexDirection: "column"
});

;// CONCATENATED MODULE: ./src/components/scrollable-date-time-picker/DateTimePicker.tsx
/* eslint-disable @typescript-eslint/no-shadow */ 





const DateTimePicker = (param)=>{
    let { initialValue =Date.now() , onChange  } = param;
    const [dateTime, setDateTime] = (0,react.useState)({
        date: dayjs_min_default()(initialValue).format("YYYY-MM-DD"),
        ampm: dayjs_min_default()(initialValue).hour() < 12 ? "AM" : "PM",
        hour: dayjs_min_default()(initialValue).hour() % 12 || 12,
        minute: dayjs_min_default()(initialValue).minute()
    });
    (0,react.useEffect)(()=>{
        const { date , hour , minute , ampm  } = dateTime;
        const formattedDate = dayjs_min_default()("".concat(date, " ").concat(hour, ":").concat(minute, " ").concat(ampm)).format("YYYY-MM-DD HH:mm");
        const timestamp = dayjs_min_default()(formattedDate).valueOf();
        onChange === null || onChange === void 0 ? void 0 : onChange(timestamp);
    }, [
        dateTime
    ]);
    const transformDateText = (date)=>{
        const weekday = dayjs_min_default()(date).weekday();
        const dateText = dayjs_min_default()(date).format("M월 D일");
        return "".concat(dateText, " (").concat([
            "일",
            "월",
            "화",
            "수",
            "목",
            "금",
            "토"
        ][weekday], ")");
    };
    const months = Array.from({
        length: 12
    }, (_, i)=>i + 1);
    const days = Array.from({
        length: 31
    }, (_, i)=>i + 1);
    const datesOfTheYear = months.flatMap((month)=>days.map((day)=>dayjs_min_default()("".concat(new Date().getFullYear(), "-").concat(month, "-").concat(day)).format("YYYY-MM-DD"))).map(transformDateText);
    const dates = [
        ...new Set(datesOfTheYear)
    ];
    const hours = Array.from({
        length: 12
    }, (_, i)=>i + 1);
    const minutes = Array.from({
        length: 60
    }, (_, i)=>"0".concat(i).slice(-2));
    const ampm = [
        "오전",
        "오후"
    ];
    const handleChange = (0,react.useCallback)((key)=>debounce_default()((value)=>{
            if (key === "date" && typeof value === "string") {
                const year = new Date().getFullYear();
                const [month, day] = value.split(" ").map((item)=>item.slice(0, -1));
                const formattedDate = dayjs_min_default()("".concat(year, "-").concat(month, "-").concat(day)).format("YYYY-MM-DD");
                setDateTime((prev)=>({
                        ...prev,
                        date: formattedDate
                    }));
                return;
            }
            if (key === "hour") {
                setDateTime((prev)=>({
                        ...prev,
                        hour: Number(value)
                    }));
                return;
            }
            if (key === "minute") {
                setDateTime((prev)=>({
                        ...prev,
                        minute: Number(value)
                    }));
                return;
            }
            if (key === "ampm") {
                setDateTime((prev)=>({
                        ...prev,
                        ampm: value === "오전" ? "AM" : "PM"
                    }));
            }
        }, 100), []);
    const pickedDate = transformDateText(dateTime.date);
    const pickedAmpm = dateTime.ampm === "AM" ? "오전" : "오후";
    const pickedHour = dateTime.hour;
    const pickedMinute = "0".concat(dateTime.minute).slice(-2);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        style: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(scrollable_date_time_picker_ScrollBox, {
                    items: dates,
                    value: pickedDate,
                    onChange: handleChange("date"),
                    width: 135,
                    align: "right"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(scrollable_date_time_picker_ScrollBox, {
                    items: ampm,
                    value: pickedAmpm,
                    onChange: handleChange("ampm"),
                    width: 60,
                    align: "right"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(scrollable_date_time_picker_ScrollBox, {
                    items: hours,
                    value: pickedHour,
                    onChange: handleChange("hour"),
                    width: 40,
                    align: "right"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Colon, {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(scrollable_date_time_picker_ScrollBox, {
                    items: minutes,
                    value: pickedMinute,
                    onChange: handleChange("minute"),
                    width: 40,
                    align: "left"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PickedBackground, {})
            ]
        })
    });
};
/* harmony default export */ var scrollable_date_time_picker_DateTimePicker = (DateTimePicker);
const Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eph29760"
})({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    position: "relative"
});
const PickedBackground = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eph29761"
})({
    position: "absolute",
    left: 0,
    right: 0,
    height: 38,
    top: "50%",
    transform: "translateY(-50%)",
    borderRadius: 8,
    zIndex: -1
}, (param)=>{
    let { theme  } = param;
    return {
        background: theme.colors.gray4
    };
});
const Colon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eph29762"
})({
    padding: "0 15px",
    "&::before": {
        content: '":"'
    }
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.button1,
        color: theme.colors.white
    };
});

;// CONCATENATED MODULE: ./src/models/alarm.ts
const weekdayPairs = [
    {
        key: "Sunday",
        value: "일"
    },
    {
        key: "Monday",
        value: "월"
    },
    {
        key: "Tuesday",
        value: "화"
    },
    {
        key: "Wednesday",
        value: "수"
    },
    {
        key: "Thursday",
        value: "목"
    },
    {
        key: "Friday",
        value: "금"
    },
    {
        key: "Saturday",
        value: "토"
    }
];
const dayPairs = [
    {
        key: "everyday",
        value: "매일"
    },
    {
        key: "weekdays",
        value: "평일"
    },
    {
        key: "weekends",
        value: "주말"
    }
];
const alarmTimeOptionPairs = [
    {
        key: "ONTIME",
        value: "정시"
    },
    {
        key: "TEN_MINUTES",
        value: "10분 전"
    },
    {
        key: "THIRTY_MINUTES",
        value: "30분 전"
    },
    {
        key: "ONE_HOUR",
        value: "1시간 전"
    },
    {
        key: "TWO_HOURS",
        value: "2시간 전"
    },
    {
        key: "ONE_DAY",
        value: "하루 전"
    },
    {
        key: "TWO_DAYS",
        value: "2일 전"
    },
    {
        key: "ONE_WEEK",
        value: "일주일 전"
    }
];
const alarmRepeatPairs = [
    {
        key: "ThisWeek",
        value: "이번 주"
    },
    {
        key: "EveryWeek",
        value: "매주"
    }
];
const alarmTypePairs = [
    {
        key: "WEEKLY",
        value: "요일별"
    },
    {
        key: "DAILY",
        value: "날짜별"
    }
];

;// CONCATENATED MODULE: ./src/store/alarm-config/daily.ts

const dailyState = (0,es/* atom */.cn)({
    key: "alarmConfig/daily",
    default: {
        alarmDateTime: Date.now(),
        timeOption: "ONTIME",
        activePicker: null
    }
});
/* harmony default export */ var daily = (dailyState);

;// CONCATENATED MODULE: ./src/components/alarm/bottom-sheet/daily-controller/ConfigPicker.tsx







const ConfigPicker = ()=>{
    const [dateInfo, setDateInfo] = (0,es/* useRecoilState */.FV)(daily);
    const { alarmDateTime , timeOption , activePicker  } = dateInfo;
    if (activePicker === "dateTime") {
        const handleChange = (changedDate)=>setDateInfo((prev)=>({
                    ...prev,
                    alarmDateTime: changedDate
                }));
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: "외출 날짜 및 시간"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(scrollable_date_time_picker_DateTimePicker, {
                        initialValue: alarmDateTime,
                        onChange: handleChange
                    })
                })
            ]
        });
    }
    if (activePicker === "timeOption") {
        const handleClick = (key)=>setDateInfo((prev)=>({
                    ...prev,
                    timeOption: key
                }));
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: "알림 희망 시간"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row, {
                    children: alarmTimeOptionPairs.map((param)=>/*#__PURE__*/ {
                        let { key , value  } = param;
                        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bottom_sheet_SelectItem, {
                            text: value,
                            active: key === timeOption,
                            onClick: ()=>handleClick(key)
                        }, key);
                    })
                })
            ]
        });
    }
    return null;
};
/* harmony default export */ var daily_controller_ConfigPicker = (ConfigPicker);
const Row = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e2zqjp00"
})({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "8px"
}, (param)=>{
    let { spaceBetween  } = param;
    return spaceBetween && {
        justifyContent: "space-between"
    };
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-5128de1cdb/0/cache/@emotion-react-npm-11.10.0-06b9abb1e2-6d692e43ff.zip/node_modules/@emotion/react/dist/emotion-element-cbed451f.browser.esm.js + 2 modules
var emotion_element_cbed451f_browser_esm = __webpack_require__(79214);
// EXTERNAL MODULE: ./src/components/svg/Svg.tsx
var Svg = __webpack_require__(24555);
;// CONCATENATED MODULE: ./src/components/icon/IconChevron20pxUpDown.tsx



const DIRECTION_DEGREE = {
    up: 0,
    down: 180
};
const IconChevron20pxUpDown = (param)=>{
    let { direction ="up" , stroke , ...rest } = param;
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSvg, {
        degree: DIRECTION_DEGREE[direction],
        size: 20,
        viewBox: "0 0 20 20",
        ...rest,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M14 11.917L10.3536 8.27059C10.1583 8.07532 9.84175 8.07532 9.64649 8.27059L6.00008 11.917",
            stroke: stroke || "#9090A0",
            strokeWidth: "1.5",
            strokeLinecap: "round"
        })
    }));
};
/* harmony default export */ var icon_IconChevron20pxUpDown = (IconChevron20pxUpDown);
const StyledSvg = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Svg/* default */.Z, {
    target: "e1jj13690"
})("transform:rotate(", (param)=>{
    let { degree  } = param;
    return degree;
}, "deg);");

;// CONCATENATED MODULE: ./src/components/alarm/bottom-sheet/Picker.tsx




const Picker = (param)=>{
    let { text , onClick , active =false  } = param;
    const theme = (0,emotion_element_cbed451f_browser_esm.a)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Picker_Wrapper, {
        onClick: onClick,
        active: active,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: text
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon_IconChevron20pxUpDown, {
                direction: active ? "up" : "down",
                stroke: active ? theme.colors.gray1 : theme.colors.gray5
            })
        ]
    });
};
/* harmony default export */ var bottom_sheet_Picker = (Picker);
const Picker_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1obtord0"
})({
    display: "flex",
    alignItems: "center",
    padding: "7px 9px 7px 16px",
    borderRadius: "8px",
    border: "none"
}, (param)=>{
    let { active , theme  } = param;
    return {
        ...theme.typographies.button2,
        color: active ? theme.colors.gray1 : theme.colors.gray5,
        backgroundColor: active ? theme.colors.black : theme.colors.gray1
    };
});

;// CONCATENATED MODULE: ./src/components/alarm/bottom-sheet/daily-controller/Header.tsx







const Header = ()=>{
    var ref;
    const [dateInfo, setDateInfo] = (0,es/* useRecoilState */.FV)(daily);
    const { alarmDateTime , timeOption , activePicker  } = dateInfo;
    const dateText = dayjs_min_default()(alarmDateTime).format("M월 D일 A h:mm");
    var ref1;
    const minutesAgoText = (ref1 = (ref = alarmTimeOptionPairs.find((param)=>{
        let { key  } = param;
        return key === timeOption;
    })) === null || ref === void 0 ? void 0 : ref.value) !== null && ref1 !== void 0 ? ref1 : "";
    const handleClickPicker = (picker)=>()=>setDateInfo((prev)=>({
                    ...prev,
                    activePicker: picker
                }));
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Header_Row, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header_Row, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bottom_sheet_Picker, {
                    text: dateText,
                    active: activePicker === "dateTime",
                    onClick: handleClickPicker("dateTime")
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Header_Row, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bottom_sheet_Picker, {
                        text: minutesAgoText,
                        active: activePicker === "timeOption",
                        onClick: handleClickPicker("timeOption")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        children: "에"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        children: "챙겨드릴게요!"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var daily_controller_Header = (Header);
const Header_Row = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1tdrh6s0"
})({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "8px"
}, (param)=>{
    let { spaceBetween  } = param;
    return spaceBetween && {
        justifyContent: "space-between"
    };
});

;// CONCATENATED MODULE: ./src/components/alarm/bottom-sheet/daily-controller/AlarmDailyController.tsx




const AlarmDailyController = ()=>{
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(daily_controller_Header, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(daily_controller_ConfigPicker, {})
        ]
    });
};
/* harmony default export */ var daily_controller_AlarmDailyController = (AlarmDailyController);
const Divider = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("hr", {
    target: "e1t9fg210"
})({
    border: "none",
    height: "1px",
    width: "100%"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.gray2
    };
});

;// CONCATENATED MODULE: ./src/components/alarm/bottom-sheet/weekly-controller/AlarmWeeklyController.tsx






const AlarmWeeklyController = ()=>{
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AlarmWeeklyController_Row, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AlarmWeeklyController_Row, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bottom_sheet_Picker, {
                                text: "평일",
                                active: true
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bottom_sheet_Picker, {
                                text: "오전 8:00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AlarmWeeklyController_Row, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bottom_sheet_Picker, {
                                text: "정시"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                children: "에"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bottom_sheet_Picker, {
                                text: "매주"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                children: "챙겨드릴게요!"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AlarmWeeklyController_Divider, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: "알림"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AlarmWeeklyController_Row, {
                children: weekdayPairs.map((param)=>/*#__PURE__*/ {
                    let { key , value  } = param;
                    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bottom_sheet_SelectItem, {
                        text: value
                    }, key);
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AlarmWeeklyController_Row, {
                children: dayPairs.map((param)=>/*#__PURE__*/ {
                    let { key , value  } = param;
                    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bottom_sheet_SelectItem, {
                        text: value
                    }, key);
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: "외출 시간"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AlarmWeeklyController_Row, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(scrollable_date_time_picker_DateTimePicker, {})
            })
        ]
    });
};
/* harmony default export */ var weekly_controller_AlarmWeeklyController = (AlarmWeeklyController);
const AlarmWeeklyController_Row = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "el3xpbh0"
})({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "8px"
}, (param)=>{
    let { spaceBetween  } = param;
    return spaceBetween && {
        justifyContent: "space-between"
    };
});
const AlarmWeeklyController_Divider = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("hr", {
    target: "el3xpbh1"
})({
    border: "none",
    height: "1px",
    width: "100%"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.gray2
    };
});

;// CONCATENATED MODULE: ./src/components/alarm/bottom-sheet/AlarmController.tsx



const AlarmController = (param)=>{
    let { alarmType  } = param;
    if (alarmType === "WEEKLY") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(weekly_controller_AlarmWeeklyController, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(daily_controller_AlarmDailyController, {});
};
/* harmony default export */ var bottom_sheet_AlarmController = (AlarmController);

// EXTERNAL MODULE: ./src/components/toggle/ToggleSwitch.tsx
var ToggleSwitch = __webpack_require__(36744);
// EXTERNAL MODULE: ./src/exceptions/CustomException.ts
var CustomException = __webpack_require__(94367);
// EXTERNAL MODULE: ./.yarn/__virtual__/@tanstack-react-query-virtual-adb565d675/0/cache/@tanstack-react-query-npm-4.1.0-7940d0afc5-aaa340cbec.zip/node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(97759);
// EXTERNAL MODULE: ./src/hooks/api/template/useGetUserTemplate.ts
var useGetUserTemplate = __webpack_require__(80460);
// EXTERNAL MODULE: ./src/lib/api.ts + 2 modules
var api = __webpack_require__(93080);
;// CONCATENATED MODULE: ./src/store/alarm-config/config.ts

const configState = (0,es/* atom */.cn)({
    key: "alarmConfig/config",
    default: {
        templateId: null,
        alarmType: "DAILY",
        isActivated: false
    }
});
/* harmony default export */ var config = (configState);

// EXTERNAL MODULE: ./src/store/route-home/currentCategory.ts
var route_home_currentCategory = __webpack_require__(28693);
;// CONCATENATED MODULE: ./src/hooks/api/alarm/useCreateAlarm.ts








const createAlarm = (data)=>(0,api/* post */.v_)("/alarm/daily", data);
const useCreateAlarm = ()=>{
    const { timeOption , alarmDateTime  } = (0,es/* useRecoilValue */.sJ)(daily);
    const { isActivated  } = (0,es/* useRecoilValue */.sJ)(config);
    const currentCategory = (0,es/* useRecoilValue */.sJ)(route_home_currentCategory/* default */.Z);
    const queryClient = (0,index_production.useQueryClient)();
    const requestDailyAlarmData = (templateId)=>({
            alarmType: "DAILY",
            templateId,
            isActivated,
            alarmDateTime: dayjs_min_default()(alarmDateTime).format("YYYY-MM-DDTHH:mm"),
            timeOption
        });
    const mutate = (0,index_production.useMutation)((templateId)=>createAlarm(requestDailyAlarmData(templateId)), {
        onSuccess: ()=>{
            queryClient.invalidateQueries([
                useGetUserTemplate/* USER_TEMPLATE_QUERY_KEY */.Q,
                currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id
            ]);
        }
    });
    return mutate;
};
/* harmony default export */ var alarm_useCreateAlarm = (useCreateAlarm);

;// CONCATENATED MODULE: ./src/hooks/api/alarm/useGetAlarm.ts





const getAlarm = (templateId)=>(0,api/* get */.U2)("/alarm?templateId=".concat(templateId));
const ALARM_QUERY_KEY = "alarm";
const useGetAlarm = (templateId)=>{
    var ref;
    const setAlarmConfig = (0,es/* useSetRecoilState */.Zl)(config);
    const setDailyAlarmConfig = (0,es/* useSetRecoilState */.Zl)(daily);
    const query = (0,index_production.useQuery)({
        queryKey: [
            ALARM_QUERY_KEY,
            templateId
        ],
        queryFn: ()=>getAlarm(templateId),
        enabled: !!templateId,
        onSuccess: (data)=>{
            if (!data.result) return;
            const { alarmType , activated , timeOption , alarmDateTime  } = data.result;
            setAlarmConfig((prev)=>({
                    ...prev,
                    alarmType,
                    isActivated: activated
                }));
            if (alarmType === "DAILY") {
                setDailyAlarmConfig((prev)=>({
                        ...prev,
                        timeOption,
                        alarmDateTime: new Date(alarmDateTime).getTime()
                    }));
                return;
            }
            if (alarmType === "WEEKLY") {
            // @todo: WEEKLY
            }
        }
    });
    return {
        ...query,
        data: (ref = query.data) === null || ref === void 0 ? void 0 : ref.result
    };
};
/* harmony default export */ var alarm_useGetAlarm = (useGetAlarm);

// EXTERNAL MODULE: ./src/store/route-home/currentUserTemplate.ts
var route_home_currentUserTemplate = __webpack_require__(85289);
;// CONCATENATED MODULE: ./src/components/alarm/bottom-sheet/AlarmBottomSheet.tsx















const AlarmBottomSheet = (param)=>{
    let { isShowing , setToClose  } = param;
    const resetAlarmConfig = (0,es/* useResetRecoilState */.rb)(config);
    const resetDailyAlarmConfig = (0,es/* useResetRecoilState */.rb)(daily);
    const { mutate  } = alarm_useCreateAlarm();
    const currentUserTemplate = (0,es/* useRecoilValue */.sJ)(route_home_currentUserTemplate/* default */.Z);
    const { refetch  } = alarm_useGetAlarm(currentUserTemplate === null || currentUserTemplate === void 0 ? void 0 : currentUserTemplate.id);
    const [{ alarmType , isActivated  }, setAlarmConfig] = (0,es/* useRecoilState */.FV)(config);
    (0,react.useEffect)(()=>{
        if (isShowing) {
            refetch();
        }
    }, [
        isShowing
    ]);
    // @memo: 날짜별 알림을 우선적으로 구현하기 위해 주석처리
    // const alarmTypeOptions = alarmTypePairs.map((pair) => pair.value);
    // const alarmTypeValue = alarmTypePairs.find((pair) => pair.key === alarmType)?.value;
    // const handleChangeAlarmType = (option: string) => {
    //   const alarmTypeKey = alarmTypePairs.find(({ value }) => option === value)?.key;
    //   if (!alarmTypeKey) return;
    //   setAlarmConfig((prev) => ({ ...prev, alarmType: alarmTypeKey }));
    // };
    const onClose = ()=>{
        resetAlarmConfig();
        resetDailyAlarmConfig();
        setToClose();
    };
    const onComplete = ()=>{
        if (!currentUserTemplate) {
            throw new CustomException/* default */.Z("유저템플릿 정보를 불러올 수 없습니다.", "UNKNOWN_ERROR");
        }
        mutate(currentUserTemplate.id);
        onClose();
    };
    const onChangeAlarmActivateToggle = ()=>{
        setAlarmConfig((prev)=>({
                ...prev,
                isActivated: !prev.isActivated
            }));
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BottomSheet/* default */.Z, {
        isShowing: isShowing,
        setToClose: onClose,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppBar/* default */.Z, {
                backButtonType: "cancel",
                title: "알림 설정",
                onClickBackButton: onClose,
                rightElement: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelButton/* default */.Z, {
                    size: "large",
                    onClick: onComplete,
                    children: "완료"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AlarmBottomSheet_Wrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Form, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AlarmBottomSheet_Row, {
                            spaceBetween: true,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    children: "알림"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleSwitch/* default */.Z, {
                                    name: "alarm",
                                    checked: isActivated,
                                    onChange: onChangeAlarmActivateToggle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bottom_sheet_AlarmController, {
                            alarmType: alarmType
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var bottom_sheet_AlarmBottomSheet = (AlarmBottomSheet);
const AlarmBottomSheet_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1neze50"
})({
    height: "60vh",
    width: "100%",
    overflowY: "scroll",
    paddingBottom: "40px"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.body1,
        color: theme.colors.gray6
    };
});
const Form = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("form", {
    target: "e1neze51"
})({
    width: "100%",
    marginTop: "8px",
    display: "flex",
    flexDirection: "column",
    gap: "24px"
});
const AlarmBottomSheet_Row = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1neze52"
})({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "8px"
}, (param)=>{
    let { spaceBetween  } = param;
    return spaceBetween && {
        justifyContent: "space-between"
    };
});

// EXTERNAL MODULE: ./src/components/icon/IconAdd.tsx
var IconAdd = __webpack_require__(52976);
;// CONCATENATED MODULE: ./src/components/icon/IconAlarmAdd.tsx


const IconAlarmAdd = (param)=>/*#__PURE__*/ {
    let { ...rest } = param;
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Svg/* default */.Z, {
        ...rest,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.0002 12.5395L19.4282 14.4867C20.2586 15.6191 19.45 17.2148 18.0458 17.2148L5.95422 17.2148C4.55 17.2148 3.74137 15.6191 4.57177 14.4867L5.99988 12.5393L5.99988 9.50027C5.99988 6.18646 8.68626 3.50009 12.0001 3.50009C15.3139 3.50009 18.0003 6.18647 18.0003 9.50027L18.0002 12.5395Z",
                fill: "#9090A0"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.17053 18.5005C9.58235 19.6658 10.6937 20.5007 12 20.5007C13.3063 20.5007 14.4176 19.6658 14.8294 18.5005H9.17053Z",
                fill: "#9090A0"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                x: "8.49988",
                y: "9.75",
                width: "7.00021",
                height: "1.50005",
                rx: "0.750023",
                fill: "white"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                x: "11.25",
                y: "14",
                width: "7.00021",
                height: "1.50005",
                rx: "0.750023",
                transform: "rotate(-90 11.25 14)",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var icon_IconAlarmAdd = (IconAlarmAdd);

;// CONCATENATED MODULE: ./src/components/icon/IconSetting.tsx


const IconSetting = (param)=>/*#__PURE__*/ {
    let { ...rest } = param;
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Svg/* default */.Z, {
        ...rest,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.4996 20H13.5009C13.6889 19.9998 13.8711 19.9374 14.0174 19.8231C14.1638 19.7087 14.2655 19.5493 14.3057 19.3712L14.6462 17.868C15.0937 17.678 15.5179 17.4403 15.9111 17.1592L17.4258 17.6272C17.6051 17.6827 17.7986 17.677 17.974 17.6111C18.1495 17.5451 18.2965 17.4229 18.3905 17.2648L19.8912 14.7424C20.0825 14.4168 20.0166 14.0056 19.7321 13.7512L18.5571 12.7112C18.6105 12.2401 18.6105 11.7647 18.5571 11.2936L19.7321 10.2536C20.0166 10 20.0825 9.588 19.8912 9.2624L18.3905 6.74C18.2965 6.58202 18.1497 6.45996 17.9744 6.39405C17.7991 6.32814 17.6058 6.32233 17.4266 6.3776L15.9111 6.8456C15.5169 6.56534 15.0925 6.32741 14.6454 6.136L14.3057 4.6296C14.2657 4.45136 14.164 4.29175 14.0177 4.17724C13.8713 4.06273 13.689 4.00019 13.5009 4H10.4996C10.3115 4.00019 10.1292 4.06273 9.98285 4.17724C9.83648 4.29175 9.73485 4.45136 9.6948 4.6296L9.35838 6.1352C9.13905 6.2272 8.92467 6.3304 8.71605 6.444C8.50002 6.5656 8.29058 6.7 8.08939 6.844L6.57469 6.376C6.3954 6.32053 6.20195 6.32623 6.02646 6.39215C5.85097 6.45807 5.704 6.58025 5.60996 6.7384L4.10927 9.2608C4.016 9.41918 3.98096 9.60359 4.00987 9.78383C4.03878 9.96406 4.12994 10.1294 4.26841 10.2528L5.4434 11.2904C5.38997 11.7615 5.38997 12.2369 5.4434 12.708L4.26841 13.748C4.13014 13.8713 4.0391 14.0365 4.01019 14.2166C3.98129 14.3967 4.01622 14.5809 4.10927 14.7392L5.61326 17.26C5.7073 17.4181 5.85427 17.5403 6.02976 17.6062C6.20525 17.6722 6.3987 17.6779 6.57799 17.6224L8.09269 17.1544C8.4862 17.4357 8.9107 17.6737 9.35838 17.864L9.69397 19.3712C9.73422 19.5494 9.83605 19.709 9.98257 19.8233C10.1291 19.9377 10.3115 20 10.4996 20ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
            fill: "#9090A0"
        })
    });
};
/* harmony default export */ var icon_IconSetting = (IconSetting);

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-5128de1cdb/0/cache/@emotion-react-npm-11.10.0-06b9abb1e2-6d692e43ff.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(32746);
// EXTERNAL MODULE: ./.yarn/__virtual__/framer-motion-virtual-12ae7d66a8/0/cache/framer-motion-npm-7.5.1-450b8d268a-7785459f34.zip/node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(55166);
// EXTERNAL MODULE: ./.yarn/__virtual__/framer-motion-virtual-12ae7d66a8/0/cache/framer-motion-npm-7.5.1-450b8d268a-7785459f34.zip/node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(66618);
// EXTERNAL MODULE: ./src/constants/motions.ts
var motions = __webpack_require__(19370);
;// CONCATENATED MODULE: ./src/components/route-home/IconCardItemCheck.tsx





const IconCardItemCheck = (param)=>{
    let { isChecked , isImportant  } = param;
    const theme = (0,emotion_element_cbed451f_browser_esm.a)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
        mode: "wait",
        children: isChecked ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(motion_minimal.m.svg, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            initial: "initial",
            animate: "animate",
            exit: "exit",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.rect, {
                    x: "2",
                    y: "2",
                    width: "20",
                    height: "20",
                    rx: "10",
                    fill: "white",
                    variants: opacityVariants,
                    custom: 1
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.path, {
                    d: "M8 12.1277L10.6861 14.8139L16 9.5",
                    stroke: "#212121",
                    strokeWidth: "2.91971",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    variants: drawVariants
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.path, {
                    d: "M10.6859 14.8139L15.9997 9.5",
                    stroke: "#FF6C3E",
                    strokeWidth: "2.91971",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    variants: drawVariants
                })
            ]
        }, "checked") : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(motion_minimal.m.svg, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            initial: "initial",
            animate: "animate",
            exit: "exit",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                    fill: "white",
                    style: {
                        opacity: isImportant ? 0.5 : 1,
                        transition: "opacity 0.3s"
                    }
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.path, {
                    d: "M10.7 10.7002L13.3861 13.3863",
                    stroke: isImportant ? theme.colors.secondary : theme.colors.gray1,
                    strokeWidth: "2.91971",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    variants: drawVariants
                })
            ]
        }, "unchecked")
    });
};
/* harmony default export */ var route_home_IconCardItemCheck = (IconCardItemCheck);
const drawVariants = {
    initial: {
        pathLength: 0,
        opacity: 0,
        transition: {
            duration: 0.3,
            ease: motions/* defaultEasing */.gc
        }
    },
    animate: {
        pathLength: 1,
        opacity: 1,
        transition: {
            duration: 0.3,
            ease: motions/* defaultEasing */.gc
        }
    },
    exit: {
        pathLength: 0,
        opacity: 0,
        transition: {
            duration: 0.3,
            ease: motions/* defaultEasing */.gc
        }
    }
};
const opacityVariants = {
    initial: {
        opacity: 0,
        transition: {
            duration: 0.3,
            ease: motions/* defaultEasing */.gc
        }
    },
    animate: (op)=>({
            opacity: op,
            transition: {
                duration: 0.3,
                ease: motions/* defaultEasing */.gc
            }
        }),
    exit: {
        opacity: 0,
        transition: {
            duration: 0.3,
            ease: motions/* defaultEasing */.gc
        }
    }
};

// EXTERNAL MODULE: ./src/hooks/api/template/useCardItemMutation.ts
var useCardItemMutation = __webpack_require__(66476);
// EXTERNAL MODULE: ./src/hooks/common/useToggle.ts
var useToggle = __webpack_require__(70193);
;// CONCATENATED MODULE: ./src/components/route-home/CardItem.tsx








const CardItemSettingBottomSheet = dynamic_default()(()=>__webpack_require__.e(/* import() */ 935).then(__webpack_require__.bind(__webpack_require__, 92935)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(92935)
            ]
    }
});
const CardItem = (param)=>{
    let { name , take , important , itemId  } = param;
    const id = (0,react.useId)();
    const [isCardItemSettingShowing, __, toggleIsCardItemSettingShowing] = (0,useToggle/* default */.Z)(false);
    const { editCardItemTakeMutation  } = (0,useCardItemMutation/* default */.Z)();
    const onChangeTakeCheckbox = (e)=>{
        editCardItemTakeMutation.mutate({
            itemId,
            isTake: e.target.checked
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardItem_Wrapper, {
                isChecked: take,
                isImportant: important,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HidedInput, {
                        id: id,
                        type: "checkbox",
                        checked: take,
                        onChange: onChangeTakeCheckbox
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconLabel, {
                        htmlFor: id,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_home_IconCardItemCheck, {
                            isChecked: take,
                            isImportant: important
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NameButton, {
                        type: "button",
                        onClick: toggleIsCardItemSettingShowing,
                        isChecked: take,
                        isImportant: important,
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardItemSettingBottomSheet, {
                itemId: itemId,
                name: name,
                important: important,
                setToClose: toggleIsCardItemSettingShowing,
                isShowing: isCardItemSettingShowing
            })
        ]
    });
};
/* harmony default export */ var route_home_CardItem = (CardItem);
const CardItem_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1pidbgs0"
})({
    position: "relative",
    display: "flex",
    gap: "8px",
    width: "fit-content",
    maxWidth: "100%",
    paddingTop: "7px",
    paddingBottom: "7px",
    paddingLeft: "8px",
    paddingRight: "10px",
    borderRadius: "8px",
    transition: "background-color 0.3s"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.gray1
    };
}, (param)=>{
    let { isImportant , theme  } = param;
    return isImportant && importantWrapperCss(theme);
}, (param)=>{
    let { isImportant , isChecked  } = param;
    return isImportant && isChecked && checkedWhenImportantWrapperCss;
});
const importantWrapperCss = (theme)=>/*#__PURE__*/ (0,emotion_react_browser_esm.css)({
        backgroundColor: theme.colors.secondary
    });
const checkedWhenImportantWrapperCss = /*#__PURE__*/ (0,emotion_react_browser_esm.css)({
    backgroundColor: "#FFD3C5"
});
const HidedInput = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("input", {
    target: "e1pidbgs1"
})({
    position: "absolute",
    clipPath: "polygon(0 0, 0 0, 0 0)"
});
const IconLabel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("label", {
    target: "e1pidbgs2"
})({
    cursor: "pointer",
    width: "24px",
    height: "24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const NameButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e1pidbgs3"
})({
    all: "unset",
    cursor: "pointer",
    display: "inline-block",
    maxWidth: "100%",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    transition: "color 0.3s"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.button2
    };
}, (param)=>{
    let { isChecked , theme  } = param;
    return isChecked && checkedButtonCss(theme);
}, (param)=>{
    let { isImportant , isChecked  } = param;
    return isImportant && isChecked && checkedWhenImportantButtonCss;
});
const checkedButtonCss = (theme)=>/*#__PURE__*/ (0,emotion_react_browser_esm.css)({
        color: theme.colors.gray3
    });
const checkedWhenImportantButtonCss = /*#__PURE__*/ (0,emotion_react_browser_esm.css)({
    color: "#C7A79C"
});

;// CONCATENATED MODULE: ./src/components/route-home/Card.tsx










const ListSettingBottomSheet = dynamic_default()(()=>__webpack_require__.e(/* import() */ 220).then(__webpack_require__.bind(__webpack_require__, 49220)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(49220)
            ]
    }
});
const CardItemAppendBottomSheet = dynamic_default()(()=>__webpack_require__.e(/* import() */ 762).then(__webpack_require__.bind(__webpack_require__, 11762)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(11762)
            ]
    }
});
const Card = (param)=>{
    let { id , templateName , alarmInfo , items , pin  } = param;
    const [isListSettingShowing, _, toggleListSettingShowing] = (0,useToggle/* default */.Z)(false);
    const [isCardItemAppendShowing, __, toggleCardItemAppendShowing] = (0,useToggle/* default */.Z)(false);
    const [isAlarmSettingShowing, ___, toggleAlarmSettingShowing] = (0,useToggle/* default */.Z)(false);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TitleHeading, {
                        children: templateName
                    }),
                    alarmInfo && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AlarmCycleSpan, {
                        children: alarmInfo
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemWrapper, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LabelButton/* default */.Z, {
                                size: "large",
                                withIcon: true,
                                onClick: toggleCardItemAppendShowing,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconAdd/* default */.Z, {}),
                                    "추가하기"
                                ]
                            }),
                            items.map((item)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_home_CardItem, {
                                    itemId: item.id,
                                    take: item.take,
                                    important: item.important,
                                    name: item.name
                                }, item.id))
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BottomButtonWrapper, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BottomButton, {
                                type: "button",
                                onClick: toggleAlarmSettingShowing,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon_IconAlarmAdd, {}),
                                    " 알림"
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BottomButton, {
                                type: "button",
                                onClick: toggleListSettingShowing,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon_IconSetting, {}),
                                    " 설정"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListSettingBottomSheet, {
                id: id,
                templateName: templateName,
                pin: pin,
                setToClose: toggleListSettingShowing,
                isShowing: isListSettingShowing
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardItemAppendBottomSheet, {
                setToClose: toggleCardItemAppendShowing,
                isShowing: isCardItemAppendShowing
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bottom_sheet_AlarmBottomSheet, {
                setToClose: toggleAlarmSettingShowing,
                isShowing: isAlarmSettingShowing
            })
        ]
    });
};
/* harmony default export */ var route_home_Card = (Card);
const Card_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1s1xh9y0"
})({
    position: "relative",
    width: "100%",
    minHeight: "410px",
    height: "100%",
    // NOTE: 100vh - DefaultAppBar - Category - Indicator - Recommend - BottomNavigation
    maxHeight: "calc(100vh - 48px - 56px - 24px - 114px - 56px)",
    padding: "20px",
    // NOTE: bottom button wrapper height
    paddingBottom: "calc(48px)",
    borderRadius: "16px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.white
    };
});
const TitleHeading = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "e1s1xh9y1"
})({
    marginBottom: "4px"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.title2,
        color: theme.colors.gray6
    };
});
const AlarmCycleSpan = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e1s1xh9y2"
})({
    display: "inline-block",
    marginBottom: "24px"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.caption2,
        color: theme.colors.gray4
    };
});
// const PinButton = styled.button({
//   all: 'unset',
//   cursor: 'pointer',
//   position: 'absolute',
//   top: '11px',
//   right: '8px',
//   width: '48px',
//   height: '48px',
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
// });
const ItemWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1s1xh9y3"
})({
    flexGrow: "1",
    overflow: "scroll",
    display: "flex",
    flexDirection: "column",
    gap: "8px"
});
const BottomButtonWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1s1xh9y4"
})({
    position: "absolute",
    bottom: "0",
    left: "0",
    width: "100%",
    height: "48px",
    display: "flex"
}, (param)=>{
    let { theme  } = param;
    return {
        borderTop: "1px solid ".concat(theme.colors.gray1)
    };
});
const BottomButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e1s1xh9y5"
})({
    all: "unset",
    cursor: "pointer",
    width: "50%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.caption2,
        color: theme.colors.gray5
    };
});

// EXTERNAL MODULE: ./src/components/button/Button.tsx
var Button = __webpack_require__(56875);
;// CONCATENATED MODULE: ./src/components/button/IconButton.tsx



const IconButton = (param)=>{
    let { children , ...rest } = param;
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
        ...rest,
        children: children
    });
};
/* harmony default export */ var button_IconButton = (IconButton);
const StyledButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Button/* default */.Z, {
    target: "e1lbo7ee0"
})({
    borderRadius: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "8px",
    width: "40px",
    height: "40px",
    "&:hover": {
        backgroundColor: "inherit"
    }
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.white,
        color: theme.colors.gray4
    };
});

// EXTERNAL MODULE: ./src/components/chip/Chip.tsx + 1 modules
var Chip = __webpack_require__(76181);
// EXTERNAL MODULE: ./src/components/graphic/Graphic.tsx + 35 modules
var Graphic = __webpack_require__(77300);
;// CONCATENATED MODULE: ./src/components/icon/IconOverflow.tsx


const IconOverflow = (param)=>/*#__PURE__*/ {
    let { ...rest } = param;
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Svg/* default */.Z, {
        ...rest,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M5 13.75C5.9665 13.75 6.75 12.9665 6.75 12C6.75 11.0335 5.9665 10.25 5 10.25C4.0335 10.25 3.25 11.0335 3.25 12C3.25 12.9665 4.0335 13.75 5 13.75Z",
                fill: "#9090A0"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M12.079 13.75C13.0455 13.75 13.829 12.9665 13.829 12C13.829 11.0335 13.0455 10.25 12.079 10.25C11.1125 10.25 10.329 11.0335 10.329 12C10.329 12.9665 11.1125 13.75 12.079 13.75Z",
                fill: "#9090A0"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M19.16 13.75C20.1265 13.75 20.91 12.9665 20.91 12C20.91 11.0335 20.1265 10.25 19.16 10.25C18.1935 10.25 17.41 11.0335 17.41 12C17.41 12.9665 18.1935 13.75 19.16 13.75Z",
                fill: "#9090A0"
            })
        ]
    });
};
/* harmony default export */ var icon_IconOverflow = (IconOverflow);

// EXTERNAL MODULE: ./src/hooks/api/category/useGetUserCategories.ts
var useGetUserCategories = __webpack_require__(63195);
// EXTERNAL MODULE: ./src/lib/analytics/record.ts
var record = __webpack_require__(70994);
;// CONCATENATED MODULE: ./src/components/route-home/category/CategorySection.tsx













const CategorySettingBottomSheet = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(406), __webpack_require__.e(618)]).then(__webpack_require__.bind(__webpack_require__, 63618)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(63618)
            ]
    }
});
const CategorySection = ()=>{
    const [isCategorySettingShowing, setCategorySettingShowing, toggleCategorySettingShowing] = (0,useToggle/* default */.Z)(false);
    const { data , currentCategory , onClickCategory  } = useCategories();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChipWrapper, {
                        children: data === null || data === void 0 ? void 0 : data.map((eachCategory)=>{
                            const isCurrentCategory = eachCategory.id === (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id);
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Chip/* default */.Z, {
                                label: eachCategory.name,
                                color: isCurrentCategory ? "black" : "default",
                                onClick: onClickCategory(eachCategory),
                                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Graphic/* default */.Z, {
                                    type: eachCategory.emoji,
                                    isAct: isCurrentCategory
                                })
                            }, eachCategory.id);
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverflowWrapper, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(button_IconButton, {
                            onClick: toggleCategorySettingShowing,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon_IconOverflow, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategorySettingBottomSheet, {
                isShowing: isCategorySettingShowing,
                setToClose: ()=>setCategorySettingShowing(false)
            })
        ]
    });
};
/* harmony default export */ var category_CategorySection = (CategorySection);
const Section = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "elqjhm30"
})({
    width: "100%",
    height: "56px",
    display: "flex",
    alignItems: "center",
    marginBottom: "8px"
});
const ChipWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "elqjhm31"
})({
    position: "relative",
    width: "calc(100% - 40px)",
    height: "100%",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    overflowX: "auto",
    "& > *": {
        flexShrink: "0"
    }
});
const OverflowWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "elqjhm32"
})({
    position: "relative"
}, (param)=>{
    let { theme  } = param;
    return {
        "&::after": {
            content: '""',
            position: "absolute",
            top: "0",
            right: "100%",
            width: "24px",
            height: "100%",
            background: "linear-gradient(to right, rgba(0, 0, 0, 0), ".concat(theme.colors.gray1, " 90%)")
        }
    };
});
const useCategories = ()=>{
    const query = (0,useGetUserCategories/* default */.Z)();
    const [currentCategory, setCurrentCategory] = (0,es/* useRecoilState */.FV)(route_home_currentCategory/* default */.Z);
    (0,react.useEffect)(()=>{
        if (!query.data) return;
        if (currentCategory) return;
        setCurrentCategory(query.data[0]);
    }, [
        query.data
    ]);
    const onClickCategory = (category)=>()=>{
            setCurrentCategory(category);
            (0,record/* default */.Z)({
                action: "사용자 카테고리 변경",
                value: category.name
            });
        };
    return {
        ...query,
        currentCategory,
        onClickCategory
    };
};

;// CONCATENATED MODULE: ./src/components/graphic/GraphicEmptyCard.tsx


const GraphicEmptyCard = (param)=>{
    let { width =222 , height =216 , viewBox ="0 0 222 216" , ...rest } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Svg/* default */.Z, {
        width: width,
        height: height,
        viewBox: viewBox,
        ...rest,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            opacity: "0.2",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                    opacity: "0.6",
                    cx: "31.7893",
                    cy: "188.975",
                    rx: "28.2424",
                    ry: "3.05324",
                    fill: "#C7C7D0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                    opacity: "0.8",
                    cx: "124.408",
                    cy: "207.454",
                    rx: "79.2911",
                    ry: "8.5443",
                    fill: "#C7C7D0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                    opacity: "0.6",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M28.9562 137.661C35.8482 136.869 40.7933 130.64 40.0013 123.748C39.2094 116.856 32.9804 111.911 26.0884 112.703C19.1964 113.495 14.2514 119.724 15.0433 126.616C15.8352 133.508 22.0643 138.453 28.9562 137.661ZM27.8659 128.209C29.5366 128.017 30.7355 126.506 30.5435 124.836C30.3515 123.165 28.8414 121.966 27.1706 122.158C25.4999 122.35 24.301 123.86 24.493 125.531C24.685 127.202 26.1951 128.401 27.8659 128.209Z",
                            fill: "#9090A0"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                            x: "6.69531",
                            y: "118.371",
                            width: "11.0843",
                            height: "36.6221",
                            rx: "3.10356",
                            transform: "rotate(-22.1155 6.69531 118.371)",
                            fill: "#464656"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                            x: "1.4375",
                            y: "128.184",
                            width: "52.909",
                            height: "52.5284",
                            rx: "7.61281",
                            transform: "rotate(-6.55488 1.4375 128.184)",
                            fill: "#C7C7D0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M135.28 43.4072C144.662 44.5021 153.156 37.7841 154.251 28.4021C155.346 19.02 148.628 10.5268 139.245 9.43181C129.863 8.33685 121.37 15.0549 120.275 24.4369C119.18 33.8189 125.898 42.3122 135.28 43.4072ZM136.78 30.5353C139.055 30.8007 141.114 29.1721 141.379 26.8977C141.644 24.6232 140.016 22.5643 137.741 22.2988C135.467 22.0334 133.408 23.662 133.143 25.9364C132.877 28.2108 134.506 30.2698 136.78 30.5353Z",
                    fill: "#9090A0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: "97.2344",
                    y: "8.88672",
                    width: "101.447",
                    height: "141.498",
                    rx: "11.2379",
                    transform: "rotate(12.9128 97.2344 8.88672)",
                    fill: "#464656"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M120.75 24.7969L132.59 26.1787",
                    stroke: "#464656",
                    strokeWidth: "1.516",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M141.859 27.2578L153.699 28.6396",
                    stroke: "#464656",
                    strokeWidth: "1.516",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M45.1492 113.881C46.7625 100.058 59.2764 90.1594 73.0998 91.7727L76.1426 92.1278C91.0502 93.8676 101.725 107.363 99.985 122.271L96.261 154.179C95.7428 158.62 91.7229 161.8 87.2824 161.281L52.7725 157.254C45.8608 156.447 40.9116 150.19 41.7183 143.278L45.1492 113.881Z",
                    fill: "#9090A0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M207.844 132.873C209.458 119.05 199.56 106.536 185.736 104.923L182.693 104.568C167.786 102.828 154.29 113.502 152.55 128.41L148.826 160.319C148.308 164.759 151.488 168.779 155.928 169.297L190.438 173.325C197.35 174.131 203.607 169.182 204.414 162.271L207.844 132.873Z",
                    fill: "#9090A0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M66.6191 82.1402C70.6523 47.5816 101.937 22.836 136.496 26.8692L138.999 27.1613C173.557 31.1946 198.303 62.4794 194.27 97.0379L185.637 171.008C184.435 181.302 175.116 188.673 164.823 187.472L74.4496 176.925C64.1557 175.723 56.7848 166.404 57.9862 156.111L66.6191 82.1402Z",
                    fill: "#C7C7D0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M168.125 173.612L171.664 143.289C174.729 117.025 155.922 93.2482 129.658 90.183C103.393 87.1177 79.6167 105.924 76.5514 132.189L73.0126 162.511C72.0631 170.647 77.8885 178.012 86.024 178.961L151.675 186.623C159.81 187.573 167.175 181.747 168.125 173.612Z",
                    fill: "#E9E9EE"
                })
            ]
        })
    });
};
/* harmony default export */ var graphic_GraphicEmptyCard = (GraphicEmptyCard);

;// CONCATENATED MODULE: ./src/components/route-home/EmptyCard.tsx







const ListAppendBottomSheet = dynamic_default()(()=>__webpack_require__.e(/* import() */ 947).then(__webpack_require__.bind(__webpack_require__, 56947)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(56947)
            ]
    }
});
const EmptyCard = ()=>{
    const [isShowingListAppend, _, toggleIsShowingListAppend] = (0,useToggle/* default */.Z)(false);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EmptyCard_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GraphicWrapper, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(graphic_GraphicEmptyCard, {})
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LabelButton/* default */.Z, {
                            withIcon: true,
                            onClick: toggleIsShowingListAppend,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconAdd/* default */.Z, {}),
                                " 추가하기"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListAppendBottomSheet, {
                isShowing: isShowingListAppend,
                setToClose: toggleIsShowingListAppend
            })
        ]
    });
};
/* harmony default export */ var route_home_EmptyCard = (EmptyCard);
const EmptyCard_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4qiog10"
})({
    width: "100%",
    minHeight: "410px",
    height: "100%",
    borderRadius: "16px",
    overflow: "hidden",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column"
});
const GraphicWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4qiog11"
})({
    width: "100%",
    height: "100%",
    flexGrow: "1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const ButtonWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4qiog12"
})({
    width: "100%",
    height: "48px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}, (param)=>{
    let { theme  } = param;
    return {
        borderTop: "1px solid ".concat(theme.colors.gray1)
    };
});

// EXTERNAL MODULE: ./.yarn/__virtual__/framer-motion-virtual-12ae7d66a8/0/cache/framer-motion-npm-7.5.1-450b8d268a-7785459f34.zip/node_modules/framer-motion/dist/es/animation/use-animation.mjs + 1 modules
var use_animation = __webpack_require__(33210);
// EXTERNAL MODULE: ./src/components/icon/IconCancelSmall.tsx
var IconCancelSmall = __webpack_require__(87329);
;// CONCATENATED MODULE: ./src/components/tag/Tag.tsx




const Tag = /*#__PURE__*/ (0,react.forwardRef)(function Tag(param, forwardedRef) {
    let { value , onClick , onClickCancel , ...rest } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Tag_Button, {
        type: "button",
        ref: forwardedRef,
        isShowingIconCancel: Boolean(onClickCancel),
        onClick: onClick,
        ...rest,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: value
            }),
            onClickCancel && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconCancelSmall/* default */.Z, {
                onClick: onClickCancel
            })
        ]
    });
});
const Tag_Button = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "ekjb3rl0"
})({
    all: "unset",
    cursor: "pointer",
    maxWidth: "100%",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    borderRadius: "8px"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.button2,
        backgroundColor: theme.colors.gray1,
        color: theme.colors.gray6
    };
}, (param)=>{
    let { isShowingIconCancel  } = param;
    return isShowingIconCancel ? {
        paddingTop: "7px",
        paddingBottom: "7px",
        paddingLeft: "8px",
        paddingRight: "4px"
    } : {
        padding: "7px 8px"
    };
});
/* harmony default export */ var tag_Tag = (Tag);

;// CONCATENATED MODULE: ./src/hooks/api/recommend-item/useGetRecommendItem.tsx




const HOME_RECOMMEND_ITEM_QUERY_KEY = "home_recommend_item";
const getRecommendItem = (categoryId)=>(0,api/* get */.U2)("/recommend/items?category=".concat(categoryId));
const useGetRecommendItem = ()=>{
    var ref;
    const currentCategory = (0,es/* useRecoilValue */.sJ)(route_home_currentCategory/* default */.Z);
    const query = (0,index_production.useQuery)({
        queryKey: [
            HOME_RECOMMEND_ITEM_QUERY_KEY,
            currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id
        ],
        queryFn: ()=>getRecommendItem(currentCategory.id),
        enabled: Boolean(currentCategory)
    });
    return {
        ...query,
        data: (ref = query.data) === null || ref === void 0 ? void 0 : ref.result
    };
};
/* harmony default export */ var recommend_item_useGetRecommendItem = (useGetRecommendItem);

;// CONCATENATED MODULE: ./src/components/route-home/RecommendSection.tsx











const HIDE_BOTTOM_POS = 84;
const RecommendSection = ()=>{
    const { onDragStart , onDragEnd , onClickToggleButton , animationControls  } = useSectionVisible();
    const { items , isLoading , appendToCard , removeFromItems  } = useRecommendItem();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
        mode: "wait",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RecommendSection_Wrapper, {
            animate: animationControls,
            drag: "y",
            dragElastic: 0,
            dragMomentum: false,
            dragConstraints: {
                top: 0,
                bottom: HIDE_BOTTOM_POS
            },
            onDragStart: onDragStart,
            onDragEnd: onDragEnd,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DragHandlerButton, {
                    type: "button",
                    onClick: onClickToggleButton,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DragHandlerSpan, {})
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LoadingHandler/* default */.Z, {
                    isLoading: isLoading,
                    fallback: undefined,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionText, {
                            children: "이런 건 어때요?"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecommendSection_ItemWrapper, {
                            children: items.map((item)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTag, {
                                    value: item.name,
                                    onClick: appendToCard(item),
                                    onClickCancel: removeFromItems(item.id)
                                }, item.id))
                        })
                    ]
                })
            ]
        }, "recommend-section")
    });
};
/* harmony default export */ var route_home_RecommendSection = (RecommendSection);
const RecommendSection_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(motion_minimal.m.section, {
    target: "eedb1e0"
})({
    position: "fixed",
    bottom: "54px",
    left: "0",
    width: "100%",
    height: "104px",
    borderRadius: "20px 20px 0 0",
    display: "flex",
    flexDirection: "column"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.white,
        padding: theme.size.layoutPadding,
        paddingTop: "28px",
        paddingBottom: "20px"
    };
});
const DragHandlerButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "eedb1e1"
})({
    all: "unset",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const DragHandlerSpan = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "eedb1e2"
})({
    width: "2.125rem",
    height: "4px",
    borderRadius: "10px"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.gray2
    };
});
const SuggestionText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "eedb1e3"
})({
    marginBottom: "8px"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.caption2,
        color: theme.colors.gray4
    };
});
const RecommendSection_ItemWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eedb1e4"
})({
    display: "flex",
    flexShrink: 0,
    gap: "8px",
    marginBottom: "22px",
    flexWrap: "nowrap",
    overflowX: "scroll",
    overflowY: "hidden"
});
const StyledTag = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(tag_Tag, {
    target: "eedb1e5"
})({
    flex: "0 0 auto",
    height: "38px"
});
const useSectionVisible = ()=>{
    const animationControls = (0,use_animation/* useAnimationControls */.E)();
    const [isVisible, setIsVisible, toggleVisible] = (0,useToggle/* default */.Z)(true);
    const isDragRef = (0,react.useRef)(false);
    const startAnimationDependsOnIsVisble = ()=>{
        if (isVisible) {
            animationControls.start(visibleMotion);
        } else {
            animationControls.start(hideMotion);
        }
    };
    const onDragStart = ()=>{
        isDragRef.current = true;
    };
    const onDragEnd = (_, info)=>{
        const isScrollHorizontal = Math.abs(info.offset.x) > Math.abs(info.offset.y);
        if (isScrollHorizontal) return;
        const shouldVisible = info.velocity.y < -50 && info.offset.y < 0;
        setIsVisible(shouldVisible);
        startAnimationDependsOnIsVisble();
        setTimeout(()=>{
            isDragRef.current = false;
        }, 0);
    };
    const onClickToggleButton = ()=>{
        if (isDragRef.current) return;
        toggleVisible();
    };
    life_cycle_useDidUpdate(()=>{
        startAnimationDependsOnIsVisble();
    }, [
        isVisible
    ]);
    return {
        onDragStart,
        onDragEnd,
        onClickToggleButton,
        animationControls
    };
};
const visibleMotion = {
    y: 0,
    transition: {
        duration: 0.5,
        ease: motions/* defaultEasing */.gc
    }
};
const hideMotion = {
    y: HIDE_BOTTOM_POS,
    transition: {
        duration: 0.5,
        ease: motions/* defaultEasing */.gc
    }
};
const useRecommendItem = ()=>{
    const { data , isLoading  } = recommend_item_useGetRecommendItem();
    const [items, setItems] = (0,react.useState)([]);
    const { createCardItemMutation  } = (0,useCardItemMutation/* default */.Z)();
    (0,react.useEffect)(()=>{
        if (!data) return;
        setItems(data.items.map((item, index)=>({
                id: index,
                name: item
            })));
    }, [
        data
    ]);
    const removeFromItems = (itemId)=>(e)=>{
            e.stopPropagation();
            setItems((prev)=>prev.filter((item)=>item.id !== itemId));
        };
    const appendToCard = (item)=>()=>{
            createCardItemMutation.mutate({
                itemName: item.name,
                important: false
            });
            removeFromItems(item.id);
        };
    return {
        items,
        isLoading,
        appendToCard,
        removeFromItems
    };
};

;// CONCATENATED MODULE: ./src/hooks/route-home/useCurrentUserTemplate.ts





const useCurrentUserTemplate = ()=>{
    const currentCategory = (0,es/* useRecoilValue */.sJ)(route_home_currentCategory/* default */.Z);
    const setCurrentUserTemplate = (0,es/* useSetRecoilState */.Zl)(route_home_currentUserTemplate/* default */.Z);
    const queryClient = (0,index_production.useQueryClient)();
    const userTemplates = queryClient.getQueryData([
        useGetUserTemplate/* USER_TEMPLATE_QUERY_KEY */.Q,
        currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id
    ]);
    const onCarouselIndexChange = (index)=>{
        if (!userTemplates) return;
        var _index;
        setCurrentUserTemplate((_index = userTemplates.result[index]) !== null && _index !== void 0 ? _index : null);
    };
    return {
        onCarouselIndexChange
    };
};
/* harmony default export */ var route_home_useCurrentUserTemplate = (useCurrentUserTemplate);

;// CONCATENATED MODULE: ./src/pages/index.page.tsx













const HomePage = ()=>{
    const [carouselWrapper, setCarouselWrapper] = (0,react.useState)(null);
    const { data , isLoading  } = (0,useGetUserTemplate/* default */.Z)();
    const { onCarouselIndexChange  } = route_home_useCurrentUserTemplate();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(category_CategorySection, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LoadingHandler/* default */.Z, {
                fallback: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FixedSpinner/* default */.Z, {}),
                isLoading: isLoading,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(carousel_Carousel.Wrapper, {
                        ref: setCarouselWrapper,
                        children: [
                            data === null || data === void 0 ? void 0 : data.map((userTemplate)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(carousel_Carousel.Item, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_home_Card, {
                                        id: userTemplate.id,
                                        templateName: userTemplate.templateName,
                                        alarmInfo: userTemplate.alarmInfo,
                                        items: userTemplate.items,
                                        userToken: userTemplate.userToken,
                                        categoryId: userTemplate.categoryId,
                                        pin: userTemplate.pin
                                    })
                                }, userTemplate.id)),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(carousel_Carousel.Item, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_home_EmptyCard, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(carousel_Carousel.Indicator, {
                        carouselWrapper: carouselWrapper,
                        onIndexChange: onCarouselIndexChange
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_home_RecommendSection, {})
        ]
    });
};
HomePage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultAppBar/* default */.Z, {}),
            page,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BottomNavigation/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var index_page = (HomePage);


/***/ }),

/***/ 28693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72208);

const currentCategoryState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "currentCategoryState",
    default: null
});
/* harmony default export */ __webpack_exports__["Z"] = (currentCategoryState);


/***/ }),

/***/ 85289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72208);

const currentUserTemplateState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "currentUserTemplateState",
    default: null
});
/* harmony default export */ __webpack_exports__["Z"] = (currentUserTemplateState);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [945,738,443,300,472,774,888,179], function() { return __webpack_exec__(58633); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);